<template>
  <b-sidebar
    id="timeline-drawer"
    bg-variant="white"
    ref="timelineDrawer"
    right
    no-header
    v-model="visible"
    class="border-left bd-left-gray"
    backdrop
    width="100%"
    style="z-index: 2000"
  >
    <MessageList
      v-if="visible"
      :showDrawerClose="true"
      @close="close"
      @toggleDetails="$emit('toggleDetails')"
    />
  </b-sidebar>
</template>

<script>
import MessageList from '../SubViews/MessageList'

export default {
  name: 'TimelineDrawer',
  components: {
    MessageList
  },
  data: () => ({
    visible: false
  }),
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .b-sidebar {
  border-left: 1.5px solid #d2ddec;
}
</style>
